export const API_URL = "https://journey-api.launchpad.com.br";
export const WS_URL = "wss://journey-chat.launchpad.com.br";